import { useQuery } from '@tanstack/vue-query';
import { computed } from 'vue';
import aanbodApi from '@/api/aanbod.api';
/**
 *
 * @param {maybeRef} lang
 * @param {maybeRef} aanbod
 */
export function useAanbodDefinitieQuery(lang, aanbod) {
  //TO-IMPROVE de key, staleTime & functie in functions steken en importeren. Zo kan deze ook gebruikt worden in fetch tijdens use next en is het minder foutgevoelig.
  const defaultQueryObject = useQuery(
    ['aanbodDefinitie', lang, aanbod],
    () => {
      return aanbodApi.getAanbodDefinitie(lang, aanbod);
    },
    // keep previous data while refetching, this prevents loading flicker
    // staleTime: 4h
    { keepPreviousData: true, staleTime: 1000 * 60 * 60 * 4 }
  );

  return {
    ...defaultQueryObject,
    homeButtonAvailable: computed(() => {
      return defaultQueryObject.data?.value?.subflows?.length > 1;
    })
  };
}

/**
 *
 * @param {queryClient} queryClient
 * @param {maybeRef} lang
 * @param {maybeRef} aanbod
 */
export function useAanbodDefinitieQueryInFunction(queryClient, lang, aanbod) {
  //TO-IMPROVE de key, staleTime & functie in functions steken en importeren. Zo kan deze ook gebruikt worden in fetch tijdens use next en is het minder foutgevoelig.
  return queryClient.fetchQuery({
    queryKey: ['aanbodDefinitie', lang, aanbod],
    queryFn: () => {
      return aanbodApi.getAanbodDefinitie(lang, aanbod);
    },
    staleTime: 1000 * 60 * 60 * 4
    // keep previous data while refetching, this prevents loading flicker
    // staleTime: 4h
  });
}
